export const composerCopy = {
  navLabel: "Composer",
  pageTitle: "Composer",
  pageDescription:
    "A modular workspace operating system for voice calibration, topic frameworks, avatars, source material, and structured briefs before drafting or publishing.",
  cards: [
    {
      title: "Voice + audience calibration",
      description:
        "Keep a master voice profile and modular audience avatars inside each workspace so briefs can be aligned before any writing begins.",
    },
    {
      title: "Flexible topic trees",
      description:
        "Model one to five columns with custom labels, progression keys, principles, and topic clusters instead of forcing one worldview onto every project.",
    },
    {
      title: "Source-aware briefing",
      description:
        "Organize primary, secondary, and supplemental material, then assemble briefs that later power planning, drafting, and publishing workflows.",
    },
  ],
} as const;
